import { render, staticRenderFns } from "./SourceProxies.vue?vue&type=template&id=50f1afe4&"
import script from "./SourceProxies.vue?vue&type=script&lang=js&"
export * from "./SourceProxies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports